module.exports = __webpack_public_path__ + "img/gamehall.ca7fd40b.png";